// extracted by mini-css-extract-plugin
export default {"icon":"HeaderVar1_icon__uofwh","title":"HeaderVar1_title__nQVVH"};